import { PROGRAM_CONTEXT_CHANGE, PROGRAM_LIST_LOAD } from './../actions/types/programTypes';

const inicialState = {
};

export default function (state = inicialState, action) {

  switch (action.type) {

    case PROGRAM_CONTEXT_CHANGE:
      return {
        ...state,
        programId: action.result.programId,
      };

    case PROGRAM_LIST_LOAD:
      return {
        ...state,
        programsList: action.result.programsList,
      };

    default:
      return state;

  }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/programReducer.js